import { render, staticRenderFns } from "./OmniDraggableList.vue?vue&type=template&id=3a9c669a&"
import script from "./OmniDraggableList.vue?vue&type=script&lang=js&"
export * from "./OmniDraggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports